import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION36: PdfComponent = {
  type: 'section',
  id: 's36',
  title: '36. Cumulative Remedies',
  content: [
    {
      type: 'altText',
      id: 's36bullets',
      content: [
        'The rights and remedies provided in this Agreement for the parties are cumulative and not exclusive of any rights and remedies provided by law.',
      ],
      boldFirst: false,
    },
  ],
};
